var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProBadgeSale = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 57 22",
  width: "1em",
  height: "1em",
  fill: "currentColor"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M56 2H2v18h54V2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M55 2H2v18h53V2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9 14.162c.938.896 2.254 1.484 4.144 1.484 2.506 0 3.892-1.246 3.892-3.122 0-2.114-2.128-2.562-3.668-2.884-1.036-.196-1.61-.364-1.61-.854 0-.406.308-.728 1.106-.728.826 0 1.848.322 2.632.966l1.316-1.722C15.818 6.448 14.516 6 13.018 6c-2.394 0-3.724 1.358-3.724 2.926 0 2.212 2.156 2.604 3.696 2.912.994.21 1.596.42 1.596.952 0 .448-.504.798-1.33.798a4.22 4.22 0 0 1-2.982-1.232L9 14.162zm17.561 1.316h2.619L25.65 6.14h-3.023l-3.515 9.338h2.619l.476-1.414h3.878l.476 1.414zM24.14 8.24l1.316 3.794h-2.619L24.14 8.24zm7.73 7.238h6.16v-2.1h-3.753V6.14H31.87v9.338zm9.41 0h6.845v-2.03h-4.438v-1.68h4.34V9.724h-4.34V8.17h4.438V6.14H41.28v9.338z"
})));
export default SvgProBadgeSale;